"use client";

import { resetPassword } from "@/api/user/resetPassword";
import { CreateNewPassword } from "@/components";
import ResetPassword from "@/components/login-flow/reset-password/reset-password";
import ResetPasswordOtpVerify from "@/components/login-flow/reset-password/reset-password-otp-verify";
import { ForgotPasswordContext } from "@/context";
import useToast from "@/hooks/useToast";
import { useMutation } from "@tanstack/react-query";
import { useParams, useRouter } from "next/navigation";
import { useContext, useState } from "react";

export const RenderForgotPasswordForm = () => {
  const router = useRouter;
  const { locale } = useParams() ?? {};
  const { step } = useContext(ForgotPasswordContext);
  const [resetPasswordError, setResetPasswordError] = useState(null);
  const [resetPasswordSuccess, setResetPasswordSuccess] = useState(null);
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");

  const { showToast } = useToast();

  const resetPasswordMutation = useMutation({
    mutationFn: resetPassword,
    onSuccess: (data) => {
      console.log(data);
      showToast({
        type: "success",
        message: "Password reset successfully!",
      });
      router.push(`/${locale}/login`);
      setResetPasswordSuccess(data?.message);
    },
    onError: (error) => {
      showToast({
        type: "error",
        message: "Password reset failed!",
      });
      setResetPasswordError(error);
    },
  });

  const handleResetPassword = (formData) => {
    resetPasswordMutation.mutate(formData);
  };

  if (step === 0) {
    return <ResetPassword mobile={mobile} setMobile={setMobile} />;
  }
  if (step === 1) {
    return <ResetPasswordOtpVerify mobile={mobile} />;
  }
  if (step === 2) {
    return (
      <CreateNewPassword
        resetPasswordError={resetPasswordError}
        password={password}
        setPassword={setPassword}
        handleResetPassword={handleResetPassword}
        mobile={mobile}
        resetPasswordSuccess={resetPasswordSuccess}
      />
    );
  }
  return null;
};

export default RenderForgotPasswordForm;
